
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Fairhousing",
      function () {
        return require("private-next-pages/Fairhousing/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Fairhousing"])
      });
    }
  